import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared';
import {MembershipPointsContainerModel} from '../../../../../../models/aggregates/crm/membership-points';
import {Core2Config} from '../../shared';


@Injectable({
  providedIn: 'root'
})
export class MembershipPointTotalService extends BaseApiTemplateService<MembershipPointsContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + 'membership-points-total';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL +  Core2Config.DOMAIN_URL_PREFIX + 'membership-points-total';
    this.endpoint_path =  Core2Config.DOMAIN_URL_PREFIX + 'membership-points-total';
    this.httpClient = http;
  }

}


